import { useAuthContext } from '../contexts/useAuthContext';

/**
 * Hook that determines if a request should be fired based on user authentication state.
 * Returns true when the user is logged in and has a valid userGroupId.
 *
 * @returns boolean indicating whether the request should be enabled
 */
export const useShouldFireRequestForLoggedInUser = (): boolean => {
  const { getCurrentUserGroupId, isLoggedIn } = useAuthContext();
  const userGroupId = getCurrentUserGroupId();

  return !!userGroupId && isLoggedIn;
};
